import { getDayOfTheWeek } from '../../utils/dates';

export const daysOrder = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export const sortDays = (a, b) => daysOrder.indexOf(a) - daysOrder.indexOf(b);

export const getHoursString = (day) =>
  `${day.opens}${day.opens_ampm || 'am'}-${day.closes}${
    day.closes_ampm || 'pm'
  }`;

export const today = (openingTimes) => {
  if (!openingTimes) return [];
  return Object.keys(openingTimes).filter(
    (day) => openingTimes[day].label === getDayOfTheWeek()
  );
};

export const getTodayOpeningTimes = (openingTimes) => {
  if (!openingTimes) return null;
  return today(openingTimes).map((day) => getHoursString(openingTimes[day]))[0];
};

export const isToday = (day) => {
  if (!day) return null;
  return getDayOfTheWeek() === day.label;
};

export const isClosedToday = (openingTimes) => {
  if (!openingTimes) return null;
  return today(openingTimes).map((day) => openingTimes[day].closed)[0];
};

export const isValid = (day) =>
  day &&
  ((day && day.label && 'opens' in day && 'closes' in day) || day.closed);

export const twelveHourClockTo24 = (time, ampm) =>
  ampm === 'pm' ? parseInt(time) + 12 : time;
